import styled from "styled-components";
import { ICardStyled } from "./interface";

export const WrapContext = styled.div<{hasRelatedTables?: boolean}>`
  display: flex;
  width: 100%;
  overflow-y: hidden;
  height: ${(props) => props.hasRelatedTables ? "calc(100vh - 220px)" : "calc(100vh - 190px)"} ;
`;

export const WrapDropDown = styled.div`
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  background: #fff;
  border: 1px solid #d3d3d3;
  border-radius: 8px;
  padding: 0.3rem 0.5rem;
  min-width: 300px;
`;


export const Card =styled.div<ICardStyled>`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;

    width: calc(100% - 2px);
    min-height: 70px;

    margin: 8px 2px;
    padding-left: 8px;

    box-shadow: rgb(0 0 0 / 16%) 0px 1.5px 3px, rgb(0 0 0 / 23%) 0px 1.5px 3px;
    background: ${(props) => props.selected ? "var(--main-color)" : "var(--card-background)"};
    
    position: relative;
    cursor: pointer;

    border-radius: 4px;

    transition: 200ms ease;

    &:hover{
        background: ${(props) => props.selected ? "var(--purple-darker)" : "var(--border-color)"};
    }

    .card-body{
        font-weight: bold;
        color: ${(props) => props.selected ? "white" : "unset"};
        overflow: hidden;
        width: 95%;

        span{
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
    }

    .card-footer{
        font-size: 0.7rem;
        color: ${(props) => props.selected ? "white" : "unset"};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
    }

    .icon-options{
        position: absolute;
        top: -4px;
        right: -8px;
    }

    .icon-favorite{
        position: absolute;
        top: 3px;
        left: 5px;
    }

    border-left: 4px solid ${(props) => props.color ?? "white"};
`;


export const SidebarItem = styled.div<{hiddenOverflow? : boolean}>`
    max-height: calc(100vh - 190px);
    width: 100%;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 100%;
`;


export const SidebarBodyKanban = styled.div`
    width: calc(100% - 20px);
    min-height: 70px;
    display: flex;
    align-items: center;
`;


export const SidebarCollapse = styled.div`
    width: 100%;
    background-color: var(--grey-soft);
    height: 35px;
    font-size: 0.85rem;
    display: flex;
    align-items: center;
    margin: 8px 8px;
    width: calc(100% - 20px);
    p{
        justify-content: center;
    }  
    &:hover{
        opacity: 0.9;
        cursor: pointer;
    }
`;
